/**
 * @generated SignedSource<<741bb43fc94fc56961b9d130bcc75c5d>>
 * @relayHash d915f83782261816b4336211c6103d91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 764cecd75971e8f1078024d1868b60270cea446db66cdceefb017d0829fffb84

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type useRealtimeAccessRequestsFlagsQuery$variables = {
  cloudId: string;
  contentId: string;
  duration?: number | null | undefined;
  limit?: number | null | undefined;
  start?: string | null | undefined;
};
export type useRealtimeAccessRequestsFlagsQuery$data = {
  readonly confluence_getLatestPendingRequests: {
    readonly latestPendingRequest: ReadonlyArray<{
      readonly creationDateTimestamp: AGG$Long | null | undefined;
      readonly creatorAaid: string | null | undefined;
      readonly id: string;
      readonly requestAccessType: ResourceAccessType;
      readonly user: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useRealtimeAccessRequestsFlagsQuery = {
  response: useRealtimeAccessRequestsFlagsQuery$data;
  variables: useRealtimeAccessRequestsFlagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": 525960,
    "kind": "LocalArgument",
    "name": "duration"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "limit"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "start"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "duration",
        "variableName": "duration"
      },
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "start",
        "variableName": "start"
      }
    ],
    "concreteType": "ConfluenceLatestPendingRequests",
    "kind": "LinkedField",
    "name": "confluence_getLatestPendingRequests",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceContentAccessRequest",
        "kind": "LinkedField",
        "name": "latestPendingRequest",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "requestAccessType"
          },
          {
            "kind": "ScalarField",
            "name": "creatorAaid"
          },
          {
            "kind": "ScalarField",
            "name": "creationDateTimestamp"
          },
          {
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRealtimeAccessRequestsFlagsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRealtimeAccessRequestsFlagsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d915f83782261816b4336211c6103d91",
    "id": "764cecd75971e8f1078024d1868b60270cea446db66cdceefb017d0829fffb84",
    "metadata": {},
    "name": "useRealtimeAccessRequestsFlagsQuery",
    "operationKind": "query",
    "text": "query useRealtimeAccessRequestsFlagsQuery($cloudId:ID!,$contentId:ID!,$duration:Int=525960,$limit:Int=10,$start:String){confluence_getLatestPendingRequests(cloudId:$cloudId,contentId:$contentId,duration:$duration,limit:$limit,start:$start){latestPendingRequest{id,requestAccessType,creatorAaid,creationDateTimestamp,user{id,displayName,photos{isPrimary,value}}}}}"
  }
};
})();

(node as any).hash = "bafa2b359abdb04e78a6227b4f62dc05";

export default node;
